import React, { useState } from "react";
import { toast } from "react-toastify";
import { AddProductsCsv } from "../../../services/Admin";
import Loader2 from "../../components/loader/Loader2";

function AddNewProduct() {
    const [isPending, setIsPending] = useState(false);


  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsPending(true);

    try {
      const fileInput = event.target.elements.products.files[0];
      const file = fileInput;
  

      if (file) {
        console.log(file);
        const response = await AddProductsCsv(file);
        toast.success("Products CSV uploaded successfully.");
        console.log(response);
      } else {
        toast.error("Please select a CSV file to upload.");
      }
    } catch (error) {
      toast.error("Failed to upload products CSV, please try again.");
      console.error(error);
    } finally {
      setIsPending(false);
    }
  };


  return (
    <div className="investment-history">
      <h1 className="main-heading">Add New Products</h1>
      {isPending && <Loader2 />}

      <br />
      <br />

      <div className="adpa-first">
  <div className="adpafi-top">
    <h2>Upload products CSV</h2>
  </div>
  <div className="adpafi-body">
    <form onSubmit={handleFormSubmit}>
      <div className="input-group">
        <label>Upload CSV</label>
        <input type="file" name="products" accept=".csv" required />
      </div>

      <div className="button-group">
        <button type="submit">Update</button>
      </div>
    </form>
  </div>
</div>
</div>
  );
}

export default AddNewProduct;
